import { combineReducers } from 'redux';
import auth from './auth_reducers';
import dashboard from './dashboard_reducers';
import hardware from './hardware_reducers';
import users from './users_reducers';
import recipes from './recipes_reducers';
import orders from './orders_reducers';
import dashboardadmin from './dashboardadmin_reducers';
import ingredients from './ingredients_reducers';
import ai from './ai_reducers';
import commerceAdmin from './commerce_admin_reducers';
import revenueBridge from './revenue_bridge_reducers';

export default combineReducers({
  auth, // instead of auth: () => { return auth }
  dashboard,
  hardware,
  users,
  recipes,
  orders,
  dashboardadmin,
  ingredients,
  ai,
  commerceAdmin,
  revenueBridge
});
